<template>
  <v-slide-group
    v-bind="$attrs"
    :value="findValue()"
    @change="$emit('input', findOutput($event))"
    show-arrows
  >
    <v-slide-item
      :disabled="$store.getters.isDisabled"
      v-for="(item, i) in items"
      :key="i"
      v-slot="{ active, toggle }"
    >
      <v-card class="ma-4" height="360" width="280" elevation="0" tile>
        <v-card
          :ripple="{ class: '' }"
          tile
          :elevation="active ? 8 : 1"
          @click="$store.getters.isDisabled ? null : toggle()"
          :color="item.color"
        >
          <v-card-text>
            <v-img v-if="item.image" :src="item.image" aspect-ratio="1" contain>
              <v-chip
                class="float-right"
                v-bind="{ color: 'blue-grey darken-2', ...item.chipProps }"
                dark
                v-if="item.chip"
              >
                {{ item.chip }}
              </v-chip>

              <div class="d-flex h-100 flex-column align-space-between">
                <v-avatar color="white" size="24" class="ma-1">
                  <v-icon v-if="active">mdi-check</v-icon>
                </v-avatar>
              </div>
            </v-img>
            <div class="mt-1" style="line-height: 1.1">
              <div class="mb-2" v-if="item.title">
                <small>{{ item.title }}</small>
              </div>
              <div v-if="item.subtitle" class="text--disabled">
                <small>{{ item.subtitle + " " }}</small>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-card>
    </v-slide-item>
  </v-slide-group>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: null,
    },

    /**
     * If null or "index", then index of option is used.
     */
    valueField: {
      type: String,
      default: "slug",
    },

    items: {
      type: Array,
      default: () => [
        {
          slug: "some-slug",
          image: "/path/to/image.jpg",
          title: "Item Title",
          subtitle: "Description",
          color: "#FFE5AA",
        },
      ],
    },
  },

  computed: {
    useIndex() {
      return !this.valueField || this.valueField === "index";
    },
  },

  methods: {
    /**
     * Find the index for slide group's value field
     */
    findValue() {
      if (this.useIndex) return this.value;
      return this.findIndex(this.value);
    },

    findIndex(value) {
      if (value !== 0 && !value) return null;
      return this.items.findIndex((item) => item[this.valueField] === value);
    },

    /**
     * Find the outpout value ([index, slug, id, ...] of selected option)
     */
    findOutput(index) {
      if (this.useIndex) return index;

      if (!index && index !== 0) return null;
      return this.items[index][this.valueField];
    },
  },
};
</script>
